"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RudderStack = void 0;
/* eslint-disable @typescript-eslint/no-non-null-assertion, import/named */
const PublicConfig_1 = require("../../Config/PublicConfig");
const axios_1 = __importDefault(require("axios"));
const Utils_1 = require("../../Utils/Utils");
// See API doc: https://rudderstack.com/docs/rudderstack-api/http-api/
class RudderStack {
    init() {
        this.dataPlaneUrl = (0, PublicConfig_1.publicConfig)().rudderStack.dataPlaneUrl;
        this.auth = { username: (0, PublicConfig_1.publicConfig)().rudderStack.token, password: "" };
        // Only for frontend
        if (typeof window !== "undefined") {
            this.blackListedFrontendEvents = {
                subscriptionConfirmation: "subscriptionConfirmation",
                topUpConfirmation: "topUpConfirmation",
                subscriptionUpgradeConfirmation: "subscriptionUpgradeConfirmation",
                payPerUseConfirmation: "payPerUseConfirmation",
                subscriptionDowngradeConfirmation: "subscriptionDowngradeConfirmation",
                extensionPageChromeButtonClick: "extensionPageChromeButtonClick",
            };
        }
    }
    identify(user, group) {
        (0, Utils_1.assertDefined)(this.dataPlaneUrl);
        // See https://rudderstack.com/docs/rudderstack-api/http-api/#5-identify
        const payload = {
            userId: user.userId,
            anonymousId: user.sessionId,
            type: "identify",
            traits: user.traits,
            channel: typeof window !== "undefined" ? "web" : "server",
            context: {
                traits: {},
                ip: user.clientIpAddr,
                locale: user.traits.locale,
                timezone: user.traits.timezone,
            },
        };
        void axios_1.default.post(this.dataPlaneUrl + "/v1/identify", payload, {
            auth: this.auth,
        });
        if (group) {
            const groupPayload = {
                userId: user.userId,
                type: "group",
                groupId: group.organisationId,
                traits: group.traits,
                channel: typeof window !== "undefined" ? "web" : "server",
                context: { traits: {}, ip: user.clientIpAddr },
            };
            void axios_1.default.post(this.dataPlaneUrl + "/v1/group", groupPayload, {
                auth: this.auth,
            });
        }
    }
    pageView(info) {
        (0, Utils_1.assertDefined)(this.dataPlaneUrl);
        const userAgent = navigator.userAgent;
        const userDeviceInformation = (0, Utils_1.getDeviceInfoFromUserAgent)(userAgent);
        const payload = {
            anonymousId: info.sessionId,
            userId: info.userId,
            channel: typeof window !== "undefined" ? "web" : "server",
            properties: {
                title: info.title,
                path: info.path,
                url: info.url,
                referrer: info.referrer,
                assumedBySuperAdmin: info.assumedBySuperAdmin,
                isVisualpingEmployee: info.isVisualpingEmployee,
            },
            context: {
                device: userDeviceInformation.device,
                os: userDeviceInformation.os,
                screen: userDeviceInformation.screen,
                userAgent: userAgent,
                traits: {}, // Could be used to update data about user?
            },
        };
        void axios_1.default.post(this.dataPlaneUrl + "/v1/page", payload, {
            auth: this.auth,
        });
    }
    track(event, isOrgEvent) {
        var _a;
        if (typeof window !== "undefined" && event.name in ((_a = this.blackListedFrontendEvents) !== null && _a !== void 0 ? _a : {})) {
            return;
        }
        let deviceInformation = {};
        if (typeof window !== "undefined" && !isOrgEvent) {
            const userAgent = navigator.userAgent;
            const userDeviceInformation = (0, Utils_1.getDeviceInfoFromUserAgent)(userAgent);
            deviceInformation = {
                device: userDeviceInformation.device,
                os: userDeviceInformation.os,
                screen: userDeviceInformation.screen,
                userAgent: userAgent,
            };
        }
        const payload = {
            anonymousId: event.sessionId,
            userId: event.userId,
            properties: Object.assign(Object.assign({}, event.properties), { eventCategory: event.category }),
            channel: typeof window !== "undefined" ? "web" : "server",
            context: Object.assign({
                traits: {},
                ip: event.clientIpAddr,
                correlationId: event.requestCorrelationId
                    ? { requestCorrelationId: event.requestCorrelationId, sessionId: event.sessionId }
                    : undefined,
            }, deviceInformation),
            event: event.name,
            timestamp: new Date().toISOString(),
        };
        void axios_1.default.post((0, Utils_1.assertDefinedAndReturn)(this.dataPlaneUrl) + "/v1/track", payload, {
            auth: this.auth,
        });
    }
}
exports.RudderStack = RudderStack;
//# sourceMappingURL=RudderStack.js.map